<template>
  <main class="grid remove-body-top-padding">
    <div class="row m-0">
      <TermsAndConditionsIndependent v-if="skin === 'cloob' || skin === 'sunnyGames'"/>
      <component
        v-else
        :is="component.configurations.isContainer ? getContainerVueComponent(component.type) : getVueComponent(component.type)"
        v-for="(component, index) in components"
        :key="index"
        :configurations="component.configurations"
        :components="component.components"
      />
    </div>
  </main>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'
import LeafComponentSelector from '@/mixins/leaf-component-selector'
import ContainerComponentSelector from '@/mixins/container-component-selector'
import TermsAndConditionsIndependent from '@/components/TermsAndConditionsIndependent'

export default Vue.extend({
  name: 'Terms',
  components:{
    TermsAndConditionsIndependent
  },
  data(){
    return{
      skin: null
    }
  },
  mixins: [
    LeafComponentSelector,
    ContainerComponentSelector
  ],
  computed: {
    ...mapGetters({
      designConfig: 'tenantDesign/config'
    }),
    components () {
      return this.designConfig.pages['terms'].components
    }
  },
  created(){
    this.skin = this.designConfig.general.Skin
  }
})
</script>
